import { useQuery } from "@tanstack/react-query";
import { api } from "@/api";

export const settingsKeys = {
	delivery: ["settings", "delivery"] as const,
};

export function useDeliveryConfig() {
	return useQuery({
		queryKey: settingsKeys.delivery,
		queryFn: () => api.settings.getDelivery(),
	});
}
